// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"1cb11f4b","128":"1cb11f4b","222":"1cb11f4b","227":"1cb11f4b","475":"1cb11f4b","550":"1cb11f4b","814":"1cb11f4b","825":"1cb11f4b"}[chunkId] + ".chunk.css";
};